import { configureStore } from '@reduxjs/toolkit'
import loginReducer from '../reducers/reducers';
import locationReducer from '../reducers/location';
import coordinateReducer from '../reducers/coordinates';
import environmentReducer from '../reducers/environment';
import { soilTestReportReducer, statsReducer } from '../reducers/dashboard';
import programReducer from '../reducers/programs';


const store = configureStore({
    reducer: {
        loginReducer,
        locationReducer,
        coordinateReducer,
        environmentReducer,
        stats: statsReducer,
        soilReport: soilTestReportReducer,
        program: programReducer,
    }
});

export default store;